import type { ReactNode } from 'react';

interface Props {
	title: string;
	children: ReactNode;
}

export const InspectorSection = ({ title, children }: Props) => (
	<div data-re-inspector-section="" data-has-title="">
		<div data-re-inspector-section-header="">
			<span data-re-inspector-text="">{title}</span>
		</div>
		<div data-re-inspector-section-body="">{children}</div>
	</div>
);
